import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { ItemMedia } from "./ItemMedia";
import { dubaiTime } from "./QueueTable";

export const ItemDetailDialog = ({ item, open, onOpenChange, children }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-3xl" data-testid="item-detail-dialog">
      <DialogHeader>
        <DialogTitle className="font-mono text-sm">{item.id}</DialogTitle>
        <DialogDescription>{item.channel} · {dubaiTime(item.scheduled_at)} Dubai · {item.media_type || "image"}</DialogDescription>
      </DialogHeader>
      <div className="rounded-[6px] overflow-hidden bg-black">
        <ItemMedia item={item} large />
      </div>
      <p className="text-sm whitespace-pre-wrap" data-testid="item-detail-caption">{item.caption}</p>
      {children}
    </DialogContent>
  </Dialog>
);
